const memoryCache = new Map<string, any>();
const pendingRequests = new Map<string, Promise<any>>();

export const withCache = async <T>(
  key: string,
  fetcher: () => Promise<T>
): Promise<T> => {
  // Return cached result from RAM if present
  if (memoryCache.has(key)) {
    return memoryCache.get(key) as T;
  }

  // Deduplicate ongoing identical requests
  if (pendingRequests.has(key)) {
    return pendingRequests.get(key) as Promise<T>;
  }

  const requestPromise = fetcher()
    .then((data) => {
      memoryCache.set(key, data);
      pendingRequests.delete(key);
      return data;
    })
    .catch((err) => {
      pendingRequests.delete(key);
      throw err;
    });

  pendingRequests.set(key, requestPromise);
  return requestPromise;
};

export const clearCache = (key?: string) => {
  if (key) {
    memoryCache.delete(key);
  } else {
    memoryCache.clear();
  }
};
